import {ERROR, UNIT} from '@di-shared/const';
import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import LinkTo from '@di-shared/features/navigate/LinkTo';
import {ROUTE_PATHS} from '@di-shared/routes';
import {SafeDrivingSectionKrProps} from '@di-shared/features/home/kr/driving/SafeDrivingSection.kr';

function SafeDrivingSectionErrorKr({vin}: SafeDrivingSectionKrProps) {
  const {t} = useInferableTranslation();
  return (
    <section className="section section_safe_score">
      <div className="section_container">
        <div className="section_container_header">
          <h3 className="body_medium_b">{t('T20045')}</h3>
          <span
            className="ic ic_arrow_forward_16px"
            aria-hidden="true"
          ></span>
        </div>
        <div className="safe_score_info">
          <strong className="safe_score_title">
            <span className="safe_score_value">{ERROR.DASH}</span>
            <span className="safe_score_unit">{t('T10056')}</span>
          </strong>
          <span className="safe_score_compare">
            <span className="score_compare_text">{t('T20052')}</span>
            <span className={'score_compare_value'}>{t('T20006_$score', {score: ERROR.DASH})}</span>
          </span>
          <div className="safe_score_percent">
            <span className="score_percent_item">
              <span className="score_percent_text">{t('T20053')}</span>
              <span className="score_percent_value">{`${ERROR.DASH}${UNIT.PERCENT}`}</span>
            </span>
            <span className="divider divider_vertical"></span>
            <span className="score_percent_item">
              <span className="score_percent_text">
                {ERROR.DASH} {t('T20053')}
              </span>
              <span className="score_percent_value">{`${ERROR.DASH}${UNIT.PERCENT}`}</span>
            </span>
          </div>
        </div>
        <div className="safe_score_summary">
          <ul className="score_summary_list">
            <li className="score_summary_item">
              <span className="ic ic_map_point_up_16"></span>
              <span className="score_summary_title">{t('T10011')}</span>
              <span className="score_summary_value">{t('T30145_$count', {count: ERROR.DASH})}</span>
            </li>
            <li className="score_summary_item">
              <span className="ic ic_map_point_down_16"></span>
              <span className="score_summary_title">{t('T10012')}</span>
              <span className="score_summary_value">{t('T30145_$count', {count: ERROR.DASH})}</span>
            </li>
            <li className="score_summary_item">
              <span className="ic ic_map_point_sudden_16"></span>
              <span className="score_summary_title">{t('T10013')}</span>
              <span className="score_summary_value">{t('T30145_$count', {count: ERROR.DASH})}</span>
            </li>
            <li className="score_summary_item">
              <span className="ic ic_map_point_night_16"></span>
              <span className="score_summary_title">{t('T20000')}</span>
              <span className="score_summary_value">{t('T30145_$count', {count: ERROR.DASH})}</span>
            </li>
          </ul>
        </div>
        <LinkTo
          to={ROUTE_PATHS.SAFE_DRIVING.getFullPath(vin)}
          className="section_container_full_btn"
        >
          <span className="blind">{t('T20087')}</span>
        </LinkTo>
      </div>
    </section>
  );
}

export default SafeDrivingSectionErrorKr;
